import { useEffect, useState } from 'react';
import { ChatOverlay } from './ChatOverlay';
import { EditorChrome } from './EditorChrome';
import { MockFrame } from './MockFrame';
import { PrismFab } from './PrismFab';
import { ReviewOverlay } from './ReviewOverlay';
import { RoutinesOverlay } from './RoutinesOverlay';
import { SheetGrid } from './SheetGrid';
import type { FeatureId } from './types';

const FAB_POP_MS = 500;
const CHAT_AFTER_FAB_MS = 100;

export function FeatureMockup({
  feature,
  active = true,
}: {
  feature: FeatureId;
  active?: boolean;
}) {
  const native = feature === 'native';
  const chat = feature === 'chat';
  const [fabOpen, setFabOpen] = useState(!chat);
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    if (!chat) return;
    if (!active) {
      setFabOpen(false);
      setChatOpen(false);
      return;
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setFabOpen(true);
      setChatOpen(true);
      return;
    }
    setFabOpen(true);
    const timeoutId = window.setTimeout(
      () => setChatOpen(true),
      FAB_POP_MS + CHAT_AFTER_FAB_MS,
    );
    return () => window.clearTimeout(timeoutId);
  }, [chat, active]);

  return (
    <MockFrame url="app.exis.pro" rounded>
      <EditorChrome
        addr={native ? 'E4' : 'A1'}
        expanded={native}
        active={active}
      >
        <SheetGrid
          wide
          selected={-1}
          selectedCell={native ? { row: 2, col: 4 } : undefined}
          proposalRange={feature === 'review' ? 'C7:C8' : undefined}
        />
        {!native && <PrismFab open={chat ? fabOpen : true} />}
      </EditorChrome>
      {feature === 'routines' && <RoutinesOverlay />}
      {feature === 'review' && <ReviewOverlay />}
      {chat && <ChatOverlay open={chatOpen} />}
    </MockFrame>
  );
}
